
const statValues = {};

let textOutput = null;

const Stats = {

    update: function(name, value)
    {
        statValues[name] = value;

        textOutput = null;
    },

    toString: function()
    {
        if (textOutput === null)
        {
            textOutput = "";

            for (let name in statValues)
            {
                if (statValues.hasOwnProperty(name))
                {
                    textOutput += name + " = " + statValues[name] + "\n";
                }
            }
        }
        return textOutput;
    }
};

export default Stats;



// WEBPACK FOOTER //
// ./src/util/stats.js